const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }
  if (!values.year) {
    errors.year = 'Esse campo não pode ficar vazio';
  }
  if (!values.initialDate) {
    errors.initialDate = 'Esse campo não pode ficar vazio';
  }
  if (!values.finalDate) {
    errors.finalDate = 'Esse campo não pode ficar vazio';
  }
  if (!values.status) {
    errors.status = 'Esse campo não pode ficar vazio';
  }
  return errors;
};

export default validate;
